import React from 'react'

const KitchenRemodelIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="currentColor"
      className={className}
      style={{ display: 'block' }}
    >
      {/* Top Cabinet/Unit */}
      <path d="M59.86,4.14V19.35H4.14V4.14H59.86m4-4H.16V23.33H63.84V.16Z" />
      {/* Lower Main Unit */}
      <path d="M59.86,23.08V59.86H4.14V23.08H59.86m4-4H.16V63.84H63.84V19.1Z" />
      {/* Oven/Drawer Insert */}
      <rect x="13.47" y="31.13" width="37.05" height="22.68" />
      <path d="M48.54,33.12V51.81H15.46V33.12H48.54m4-4h-41V55.79h41V29.14Z" />
      {/* Knob 1 */}
      <path d="M14.87,14.58a2.83,2.83,0,1,1,2.83-2.83A2.83,2.83,0,0,1,14.87,14.58Z" />
      <path d="M14.87,10.91a.84.84,0,1,1-.84.84.84.84,0,0,1,.84-.84m0-4a4.82,4.82,0,1,0,4.82,4.82,4.82,4.82,0,0,0-4.82-4.82Z" />
      {/* Knob 2 */}
      <path d="M49.31,14.58a2.83,2.83,0,1,1,2.83-2.83A2.84,2.84,0,0,1,49.31,14.58Z" />
      <path d="M49.31,10.91a.84.84,0,1,1,0,1.68.84.84,0,1,1,0-1.68m0-4a4.82,4.82,0,1,0,4.82,4.82,4.82,4.82,0,0,0-4.82-4.82Z" />
      {/* Knob 3 */}
      <path d="M32,14.58a2.83,2.83,0,1,1,2.83-2.83A2.83,2.83,0,0,1,32,14.58Z" />
      <path d="M32,10.91a.84.84,0,1,1-.84.84.84.84,0,0,1,.84-.84m0-4a4.82,4.82,0,1,0,4.82,4.82A4.82,4.82,0,0,0,32,6.93Z" />
    </svg>
  )
}

export default KitchenRemodelIcon
